export enum translatQueryKeys {
    TRANSLAT_INFO = 'TRANSLAT_INFO'
}

export enum tdkQueryKeys {
    TDK_INFO = 'TDK_INFO',
    SYMBOL_INFO = 'SYMBOL_INFO'
}

export enum tickerQueryKeys {
    FUTUTRS_TICKER = 'FUTUTRS_TICKER',
    SPOT_TICKER = 'SPOT_TICKER'
}

export enum c2cQueryKeys {
    C2C_HOME_TAB = 'C2C_HOME_TAB',
    C2C_HOME_TAB_LIST = 'C2C_HOME_TAB_LIST'
}
